import { Link } from "react-router-dom";

import GuideModal from "../modals/GuideModal";

import { useModalStore } from "../stores/Modal";

const Nav = ({
  type = "main",
  title,
  prev = false,
  onClose = () => {},
  onPrev = () => {},
}) => {
  const { openModal, closeModal } = useModalStore();

  const handleClickGuide = () => {
    openModal(<GuideModal key="guide-modal" />);
  };

  const handleClickCloseModal = () => {
    onClose();
    closeModal();
  };

  const handleClickPrev = () => {
    onPrev();
  };

  if (type === "modal") {
    return (
      <div className="fixed top-0 left-0 right-0 bg-gray-1 z-[20]">
        <div className="py-12 px-16 mx-auto max-w-[736px] w-full bg-white flex justify-start items-center border-b-1 border-b-gray-9">
          {prev && (
            <button type="button" onClick={handleClickPrev}>
              <img
                src="/assets/images/icon-prev.svg"
                alt="이전"
                className="w-18"
              />
            </button>
          )}
          <h2 className="flex-1 text-center text-neutral-10 text-13 font-semibold leading-[20px] tracking-[0.013px]">
            {title}
          </h2>
          <button type="button" onClick={handleClickCloseModal} className="p-7">
            <img
              src="/assets/images/icon-close.svg"
              alt="닫기"
              className="w-18"
            />
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed top-0 left-0 right-0 bg-gray-1">
      <div className="py-12 px-16 mx-auto max-w-[736px] w-full bg-primary-6">
        <div className="max-w-[420px] w-full mx-auto flex justify-between items-center">
          <div>
            <Link to="/">
              <img
                src="/assets/images/logo.svg"
                alt="무의 로고"
                className="h-16"
              />
            </Link>
          </div>
          <div>
            <button
              type="button"
              className="flex justify-start items-center py-7 px-10 text-gray-2 text-12 font-bold leading-[16px] tracking-[0.06px]"
              onClick={handleClickGuide}
            >
              이용방법
              <img
                src="/assets/images/icon-question.svg"
                alt=""
                className="w-18 ml-8"
              />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Nav;
